import { Helmet } from "react-helmet-async"
import { WebhookClientCallsList } from "../../../Admin/WebhookClientCalls"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"

export default function WebhookClientCallsListPage() {
	return (
		<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_TENANTS}>
			<Helmet>
				<title>Webhook Client Calls</title>
			</Helmet>
			<WebhookClientCallsList />
		</ForbidUnlessAuthorized>
	)
}
